// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Close = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Close = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Close = _exports.Close = function Close(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M16.3528 5.05931C16.743 4.66903 16.743 4.03796 16.3528 3.65184C15.9625 3.26572 15.3314 3.26156 14.9453 3.65184L10.0046 8.59251L5.05979 3.64768C4.66952 3.25741 4.03844 3.25741 3.65232 3.64768C3.2662 4.03796 3.26205 4.66903 3.65232 5.05515L8.593 9.99583L3.64817 14.9407C3.2579 15.3309 3.2579 15.962 3.64817 16.3481C4.03844 16.7342 4.66952 16.7384 5.05564 16.3481L9.99632 11.4074L14.9411 16.3523C15.3314 16.7425 15.9625 16.7425 16.3486 16.3523C16.7347 15.962 16.7389 15.3309 16.3486 14.9448L11.4079 10.0041L16.3528 5.05931Z",
      fill: "currentColor"
    }));
  };
});
